<g-empty-state
  [headline]="'Page not found'"
  [body]="title"
  [src]="'assets/imgs/empty_basket.svg'"
>

</g-empty-state>